import { createBrowserHistory } from "history";

const historyObject:any = createBrowserHistory({ window });
export default historyObject;